export const GAME_CONFIG = {
  SELECTION_TOLERANCE_FACTOR: 0.6,

  TOLERANCE_DIRECTION_FACTORS: {
    HORIZONTAL: 0.5,
    VERTICAL: 0.5
  },

  LETTER_FONT_WEIGHT: {
    MIN_WEIGHT: 300,
    MAX_WEIGHT: 500,
    MIN_GRID_SIZE: 8,
    MAX_GRID_SIZE: 15
  },

  ANIMATION_DELAY: 200,
};
